import React from "react";
import { useForm } from "react-hook-form";
import { CirclePlus } from "lucide-react";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import CustomInput from "../../../components/UI/PageInput/CustomInput";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import DateInput from "../../../components/UI/PageInput/DateInput";
import successIcon from "../../../assets/icons/successIcon.svg";
import DialogBox from "../../../components/UI/DialogBox";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import { noSpaceOnlyValidation } from "../../../validations/formValidations";

const AddMachineComponentForm = ({
  machineSetup,
  sendData,
  loading,
  navigate,
  successResponse,
}) => {
  const machinesArray = machineSetup.machines.map((item) => ({
    id: item.station.machineID,
    name: item.station.name,
  }));
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useForm();

  const fgDate = watch("fgDate");

  const onSubmit = (data) => {
    sendData(data, reset);
  };
  return (
    <>
      <div className="form-container ">
        <CenteredHeading title="Add Machine Component" />
        <form
          onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        >
          <div className="flex flex-wrap">
            <div className="halfCol">
              <div className="px-1">
                <SearchDropdown
                  name="categoryId"
                  label="Category *"
                  keyName="name"
                  id="id"
                  options={machineSetup.categories}
                  setValue={setValue}
                  control={control}
                  selectedVal={watch("categoryId")}
                  error={errors.categoryId}
                />
                <CustomInput
                  type="text"
                  name="cardNumber"
                  labelText="Card Name *"
                  placeholder="Enter"
                  register={{
                    ...register("cardNumber", {
                      required: "Please Enter a card number",
                      noSpaceOnlyValidation,
                    }),
                  }}
                  error={errors.cardNumber}
                />
              </div>
            </div>
            <div className="halfCol">
              <div className="px-1">
                <SearchDropdown
                  name="machineId"
                  label="Machine *"
                  keyName="name"
                  id="id"
                  options={machinesArray}
                  setValue={setValue}
                  control={control}
                  selectedVal={watch("machineId")}
                  error={errors.machineId}
                  search={true}
                />
                <DateInput
                  label="Date *"
                  name={"fgDate"}
                  value={fgDate}
                  setValue={setValue}
                  register={{
                    ...register("fgDate", {
                      required: "Please Select date",
                    }),
                  }}
                  error={errors.fgDate}
                />
              </div>
            </div>
          </div>
          <div className="addBtn---wrap gap-2">
            <PrimaryButton
              btnText={!loading ? "Add Machine Component" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
            />
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
          </div>
        </form>
      </div>
      {successResponse && (
        <DialogBox
          message="Successfully Machine Component"
          messageIcon={successIcon}
          btnText="Ok"
          closeAction={() => navigate("/site/all-machine")}
        />
      )}
    </>
  );
};

export default AddMachineComponentForm;
